import {
  getUserPointsById,
  getUserDetailsById,
  insertUserManager,
  updateUserById,
  getUserPointsList,
  updateUserPoints,
  getUserTransactions,
  emailPassword,
} from "@/api/user-manager";
import { UTCToLocale, localeToUTC } from "@/utilities/date.js";

const userManager = {
  namespaced: true,

  state: () => ({
    users: {},
    userDetail: {},
    usersPoint: [],
    pagination: {
      pageNo: 1,
      recordsPerScreen: 5,
      recordCountEachScreen: 0,
      sortField: "LASTNAME",
      sortOrder: "ASC",
      totalRecords: 0,
    },
    filterDataForUserManager: {
      companyId: 0,
      userType: 0,
      status: 2,
      recordsPerScreen: 5,
      search: "",
    },
  }),

  getters: {
    getUsers(state) {
      return state.users;
    },
    getUserDetail(state) {
      return state.userDetail;
    },
    getUsersPoint(state) {
      return state.usersPoint;
    },
    getPagination(state) {
      return state.pagination;
    },
    getFilterDataForUserManager(state) {
      return state.filterDataForUserManager;
    },
  },

  actions: {
    emailPassword({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        emailPassword(params)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.log("error while emailPassword store" + err);
          });
      });
    },

    fetchUserPointsById({ commit }, userId) {
      return new Promise((resolve, reject) => {
        getUserPointsById(userId)
          .then((resp) => {
            commit("SET_USERS", resp);
          })
          .catch(() => {
            console.log("first error occured");
          });
      });
    },

    addUserManager({ commit }, params) {
      return new Promise((resolve, reject) => {
        console.log(params);
        insertUserManager(params)
          .then((userId) => {
            resolve(userId);
          })
          .catch(() => {
            console.log("error");
          });
      });
    },

    editUserManager({ commit }, params) {
      return new Promise((resolve, reject) => {
        console.log(params);
        updateUserById(params)
          .then((userId) => {
            resolve(userId);
          })
          .catch(() => {
            console.log("erro occured");
          });
      });
    },

    fetchUserDetailsById({ commit }, userId) {
      return new Promise((resolve, reject) => {
        console.log(userId);
        getUserDetailsById(userId)
          .then((resp) => {
            resp.editeddate = UTCToLocale(resp.editeddate);
            resp.loginDate = UTCToLocale(resp.loginDate);
            resp.createddate = UTCToLocale(resp.createddate);
            commit("SET_USER_DETAIL", resp);
          })
          .catch(() => {
            console.log("error occured ..");
          });
      });
    },

    fetchUserPointsList({ commit }, params) {
      return new Promise((resolve, reject) => {
        console.log(params);
        getUserPointsList(params)
          .then((resp) => {
            console.log(resp, "hello");
            if (resp.totalRecords === 0) {
              commit("SET_USERS_POINT", []);
            } else {
              commit("SET_USERS_POINT", resp.Result);
            }
            commit("SET_USERS_PAGINATION", {
              pageNo: resp.pageNumber,
              recordsPerScreen: resp.pageSize,
              recordCountEachScreen: resp.selectedRecordCount,
              sortField: resp.sortField,
              sortOrder: resp.sortOrder,
              totalRecords: resp.totalRecords,
            });
          })
          .catch(() => {
            console.log("some error while fetching list");
          });
      });
    },

    emptyUserPointList({ commit }) {
      commit("SET_USERS_POINT", []);
      commit("SET_USERS_PAGINATION", {
        pageNo: 1,
        recordsPerScreen: 5,
        recordCountEachScreen: 0,
        sortField: "",
        sortOrder: "",
        totalRecords: 0,
      });
    },

    updateUserPoints({ commit }, params) {
      return updateUserPoints(params);
    },
    getUserTransactions({ commit }, params) {
      return new Promise((resolve, reject) => {
        getUserTransactions(params)
          .then((resp) => {
            // if (resp.data) {
            //   resp.data.Result.map((record) => {
            //     record.date = UTCToLocale(record.date);
            //   });
            // }
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
  },

  mutations: {
    SET_USERS: (state, users) => {
      state.users = users;
    },
    SET_USER_DETAIL: (state, userDetail) => {
      state.userDetail = {
        ...userDetail,
        name: userDetail.firstName + " " + userDetail.lastName,
      };
    },
    SET_USERS_POINT: (state, userPoints) => {
      state.usersPoint = userPoints;
    },
    SET_USERS_PAGINATION: (state, pagination) => {
      state.pagination = pagination;
    },
    SET_FILTER_DATA_FOR_USER_MANAGER: (state, payload) => {
      state.filterDataForUserManager = payload;
    },
  },
};

export default userManager;
